export const evaluatePredicate = (predicate, state) => {
  if (predicate.all) {
    return predicate.all.every((condition) =>
      evaluateCondition(condition, state)
    );
  }
  if (predicate.any) {
    return predicate.any.some((condition) =>
      evaluateCondition(condition, state)
    );
  }
  return evaluateCondition(predicate, state);
};

export const evaluateCondition = (condition, state) => {
  const value = getNestedValue(state, condition.path);
  switch (condition.op) {
    case "eq":
      return value === condition.value;
    case "in":
      return Array.isArray(condition.value) && condition.value.includes(value);
    default:
      return false;
  }
};

export const getNestedValue = (obj, path) => {
  return path.split(".").reduce((current, key) => current?.[key], obj);
};
